import { SearchTerm } from './SearchTerm';

const ExpiredCredentialReportSearch: SearchTerm[] = [
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "name"
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        searchOnName: "mstIdnumber",
        translationKey: "uniqueIdentifier"
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        searchOnName: "tagCode",
        translationKey: "cardNumber"
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "mtName",
        translationKey: "type"
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        searchOnName: "mstSuffix",
        translationKey: "suffix"
    },
    {
        heading: "Company",
        accessor: "companyName",
        searchOnName: "compName",
        translationKey: "company"
    },
    {
        heading: "Department",
        accessor: "departmentName",
        searchOnName: "deptName",
        translationKey: "department"
    },
    {
        heading: "Expired",
        accessor: "expired",
        searchOnName: "expired",
        translationKey: "expired"
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName"
    },
    {
        heading: "Middle Name",
        accessor: "middleName",
        searchOnName: 'mstMiddlename',
        translationKey: "secondName"
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: 'mstLastname',
        translationKey: "lastName"
    },
    {
        heading: "Title",
        accessor: "title",
        searchOnName: 'mstTitle',
        translationKey: "title"
    },
    // {
    //     heading: "Access Type",
    //     accessor: "access",
    //     searchOnName: 'mtName',
    //     translationKey: "accessType"
    // },
    {
        heading: "Category",
        accessor: "category",
        searchOnName: 'profileName',
        translationKey: "category"
    }
];

export default ExpiredCredentialReportSearch;
